import {
  RESERVATIONS_CONCIERGE_MULTIPLE_TABLES_PATH,
  RESERVATIONS_CONCIERGE_MULTIPLE_TABLES_TERMINAL_PATH,
  RESERVATIONS_CONCIERGE_PATH,
  RESERVATIONS_CONCIERGE_TERMINAL_PATH,
} from 'restaurantAdmin/paths';
import { useAuth } from 'restaurantAdmin/context/AuthContext';
import { MOBILE } from '@shared/styles/breakpoints';
import cx from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { Link, useLocation, useSearchParams } from 'react-router-dom';
import typography from '~styles/typography.scss';
import styles from './ConciergePage.scss';

export const ConciergePageNavLinks = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const isMobile = useMediaQuery({ maxWidth: MOBILE });
  const { isManager } = useAuth();

  const navLinkClassNames = ({ isActive }: { isActive: boolean }) =>
    cx({
      [typography.h7m]: true,
      [styles.navLink]: true,
      [styles.active]: isActive,
    });

  if (isMobile || !isManager) {
    return null;
  }

  return (
    <div>
      <Link
        className={navLinkClassNames({
          isActive: !!location.pathname.match(
            new RegExp(`/${RESERVATIONS_CONCIERGE_TERMINAL_PATH}$`),
          ),
        })}
        to={`${RESERVATIONS_CONCIERGE_PATH}?${searchParams.toString()}`}
      >
        Normal
      </Link>

      <Link
        className={navLinkClassNames({
          isActive: !!location.pathname.match(
            new RegExp(
              `/${RESERVATIONS_CONCIERGE_MULTIPLE_TABLES_TERMINAL_PATH}$`,
            ),
          ),
        })}
        to={`${RESERVATIONS_CONCIERGE_MULTIPLE_TABLES_PATH}?${searchParams.toString()}`}
      >
        God Mode
      </Link>
    </div>
  );
};
